import $ from 'jquery';
import '../lib/addtocalender';

const apiGateway = `${window.location.origin}/${$("[data-js='event-detail-url']").attr('value')}`;


const lang = document.documentElement.lang;
const eventModal = () => {
  $('#event-modal')
    .on('show.bs.modal', (event) => {
      const button = $(event.relatedTarget);
      const eventId = button.data('js');
      const object = {
        Name: 'The Emirates International Program for Zakat of Companies - Fourth Generation',
        NameAr: 'برنامج الإمارات العالمي لاحتساب زكاة الشركات - الجيل الرابع',
        Description: "Reviewing the innovative aspects of the Zakat calculation program and taking the visitors' comments and impressions about the program",
        DescriptionAr: 'استعراض الجوانب الابتكارية في برنامج احتساب زكاة الشركات، وأخذ تعليقات الزائرين وانطباعاتهم عن البرنامج',
        StartDate: '/Date(1548979200000)/',
        EndDate: '/Date(1549497600000)/',
        StartTime: '/Date(1579500000000)/',
        EndTime: '/Date(1579536000000)/',
        EventLocation: 'Abu Dhabi Corniche',
        EventLocationAr: 'كورنيش أبوظبي',
        EventCategory: 'Education, Technology, Fintech',
        EventType: 'Competition',
        Website: 'www.zakatfund.gov.ae/zfp/web/',
        BannerImageUrl: 'http://localhost:60876/images/default-source/event-library/شعار-الصندوق-(كبير)-jpg851185cd586a6dae8e8fff0000e747d6?sfvrsn=b1a69a5a_0&download=true',
        ThumbnailImageUrl: 'http://localhost:60876/images/default-source/event-library/شعار-الصندوق-(صغير)-jpg951185cd586a6dae8e8fff0000e747d6?sfvrsn=f8e51457_0&download=true',
        OpenToPublic: true,
        ByRegistration: false,
        FeaturedEvent: false
      };

      /*  const {
        Description, DescriptionAr, BannerImageUrl, Name, NameAr, StartDate, EndDate, EventLocation, EventLocationAr, Website
      } = object;
      const title = lang === 'ar' ? NameAr : Name;
      const content = lang === 'ar' ? DescriptionAr : Description;
      const location = lang === 'ar' ? EventLocationAr : EventLocation;
      const startDate = new Date(eval(StartDate.replace(/\//g, '')));
      const endDate = new Date(eval(EndDate.replace(/\//g, '')));
      const eventStartDay = startDate.getDate();
      const eventStartMonth = monthShortNames[startDate.getMonth()];
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      const duration = `Start Date: ${startDate.toLocaleString('en-IN', options)} - End Date: ${endDate.toLocaleString('en-IN', options)}`;
      const durationAr = ` تاريخ البدء: ${startDate.toLocaleString('ar-EG', options)} - تاريخ الانتهاء: ${endDate.toLocaleString('ar-EG', options)}`;
      const eventCity = $(button).find('.event-type').text();
      $('.js-title').text(title);
      $('.js-day').text(eventStartDay);
      $('.js-month').text(eventStartMonth);
      $('.js-location').text(eventCity);
      $('.js-location-address').text(location);
      $('.js-event-duration').text(lang === 'ar' ? durationAr : duration);
      $('.js-header').css({ 'background-image': `url(${BannerImageUrl})`, 'background-size': 'cover', 'background-position': 'center' });
      $('.js-content').empty().prepend(content);
      $('.js-event-url').attr('href', `https://${Website}`).attr('target', '_blank').text(`https://${Website}`);
      $('.event-modal .event-type').removeClass().addClass('event-type js-location'); */


      $.get(`${apiGateway}?id=${eventId}`, (result) => {
        const {
          Description, DescriptionAr, BannerImageUrl, Name, NameAr, StartTime, EndTime, EventLocation, EventLocationAr, Website
        } = result;
        const title = lang === 'ar' ? NameAr : Name;
        const content = lang === 'ar' ? DescriptionAr : Description;
        const location = lang === 'ar' ? EventLocationAr : EventLocation;
        const startDate = eval(`new ${StartTime.replace(/\//g, '')}`);
        const endDate = eval(`new ${EndTime.replace(/\//g, '')}`);
        const eventStartDay = startDate.getDate();
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        const duration = `Start Date: ${startDate.toLocaleString('en-IN', options)} - End Date: ${endDate.toLocaleString('en-IN', options)}`;
        const durationAr = ` تاريخ البدء: ${startDate.toLocaleString('ar-EG', options)} - تاريخ الانتهاء: ${endDate.toLocaleString('ar-EG', options)}`;
        const eventCity = $(button).find('.event-type').text();
        $('.js-title').text(title);
        $('.js-day').text(eventStartDay);
        $('.js-day').text(eventStartDay);
        $('.js-event-start-date').text(startDate.toLocaleString('en-US'));
        $('.js-event-end-date').text(endDate.toLocaleString('en-US'));
        $('.js-event-description').text(content.split('.')[0]);
        $('.js-month').text($(button).find('.event-month').text());
        $('.js-location').text(eventCity);
        $('.js-location-address').text(location);
        $('.js-event-duration').text(lang === 'ar' ? durationAr : duration);
        $('.js-header').css({ 'background-image': `url(${BannerImageUrl})` });
        $('.js-content').empty().prepend(content);
        $('.js-event-url').attr('href', `${Website}`).attr('target', '_blank').text(`${Website}`);
        $('.event-modal .event-type').removeClass().addClass('event-type js-location');
      });
    });
};


export default () => {
  eventModal();
};
